export type JobsTrafficSplitDestination = 'employers-home' | 'your-jobs';

interface JobsTrafficSplitInput {
    buyerUrl?: string;
    eligible: boolean;
    fallbackUrl: string;
    destination?: JobsTrafficSplitDestination;
}

export function getJobsTrafficSplitUrl({
    buyerUrl,
    eligible,
    fallbackUrl,
    destination = 'employers-home',
}: JobsTrafficSplitInput): string {
    if (!eligible || !buyerUrl) {
        return fallbackUrl;
    }

    const employersUrl = `${buyerUrl.replace(/\/$/, '')}/employers/`;
    return destination === 'your-jobs' ? `${employersUrl}your-jobs` : employersUrl;
}
